import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

// Inline SVG components (same as before)
const CloseIcon = ({ size = 24, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const DownloadIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const ViewIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const MaximizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
  </svg>
);

const MinimizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
  </svg>
);

// Additional icons for product features
const NegativeInventoryIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 7h-9"></path>
    <path d="M20 17h-9"></path>
    <path d="M13.5 3.5L9 9l4.5 5.5"></path>
    <path d="M3 13h4"></path>
    <path d="M3 17h4"></path>
  </svg>
);

const BatchIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="9" y1="9" x2="15" y2="9"></line>
    <line x1="9" y1="15" x2="15" y2="15"></line>
  </svg>
);

const BOMIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 7L12 12L22 7L12 2Z"></path>
    <path d="M2 17L12 22L22 17"></path>
    <path d="M2 12L12 17L22 12"></path>
  </svg>
);

const ProductionIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
  </svg>
);

const PackingIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
    <line x1="12" y1="22.08" x2="12" y2="12"></line>
  </svg>
);

const SerialIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
);

const API_URL = '/api';
const SCREEN_NAME = 'ProductMaster';

const ProductViewModal = ({ open, onClose, productCode }) => {
  const [loadingFile, setLoadingFile] = useState(null);
  const [isMaximized, setIsMaximized] = useState(false);
  const [branches, setBranches] = useState([]);
  const [loadingBranches, setLoadingBranches] = useState(true);
  const [productData, setProductData] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [screenConfig, setScreenConfig] = useState(null);
  const [showDepartmentField, setShowDepartmentField] = useState(false);
  
  // BOM-related state
  const [productionBomHeaders, setProductionBomHeaders] = useState([]);
  const [packingBomHeaders, setPackingBomHeaders] = useState([]);
  const [loadingProductionBomHeaders, setLoadingProductionBomHeaders] = useState(false);
  const [loadingPackingBomHeaders, setLoadingPackingBomHeaders] = useState(false);

  const [loading, setLoading] = useState(false);

  // truthy + header visibility logic
  const truthy = (v) => {
    if (v === undefined || v === null) return false;
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return v === 1;
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      return s === '1' || s === 'true' || s === 'yes' || s === 'on';
    }
    return Boolean(v);
  };

  const shouldShowDepartmentOnHeader = (cfg) => {
    if (!cfg) return false;
    const showHeader = truthy(cfg.ShowOnHeader) || truthy(cfg.showOnHeader);
    const showScreen = truthy(cfg.ShowOnScreen) || truthy(cfg.showOnScreen);
    return showHeader && showScreen;
  };

  // Function to fetch branches
  const fetchBranches = async () => {
    setLoadingBranches(true);
    try {
      const response = await fetch(`${API_URL}/branches`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      const data = await response.json();
      setBranches(data);
    } catch (error) {
      console.error('Error fetching branches:', error);
    } finally {
      setLoadingBranches(false);
    }
  };

  // Function to fetch departments
  const fetchDepartments = async () => {
    setLoadingDepartments(true);
    try {
      const response = await fetch(`${API_URL}/departments`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      const data = await response.json();
      setDepartments(data);
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartments([]);
    } finally {
      setLoadingDepartments(false);
    }
  };

  // Function to fetch product details
 const fetchProductDetails = async () => {

   if (!productCode) {
        console.warn("ProductCode is missing, skipping fetch.");
        return;
    }
    setLoadingProduct(true);
    try {
      // Call the API route you provided
      const res = await fetch(`${API_URL}/products/${productCode}`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      if (!res.ok) throw new Error('Failed to fetch product');
      const data = await res.json();
      setProductData(data);
    } catch (error) {
      console.error(error);
      alert("Error fetching product details");
    } finally {
      setLoadingProduct(false);
    }
  };

  // Function to fetch BOM headers by type
  const fetchBomHeadersByType = async (bomType, setHeaders, setLoading) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/bom/headers?type=${encodeURIComponent(bomType)}`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      const data = await response.json();
      setHeaders(data);
    } catch (error) {
      console.error(`Error fetching ${bomType} headers:`, error);
      setHeaders([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch department screen-config
  const fetchScreenConfig = async () => {
    try {
      const res = await fetch(`${API_URL}/screen-config/${encodeURIComponent(SCREEN_NAME)}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      });
      if (!res.ok) {
        let body = null;
        try { body = await res.json(); } catch (e) {}
        const msg = body?.message ? body.message : `Server returned ${res.status}`;
        throw new Error(msg);
      }
      const data = await res.json();
      const cfg = Array.isArray(data) ? (data[0] || null) : data;
      setScreenConfig(cfg);
      
      const shouldShowDepartment = shouldShowDepartmentOnHeader(cfg);
      setShowDepartmentField(shouldShowDepartment);
      
      if (shouldShowDepartment) {
        fetchDepartments();
      }
      
      return cfg;
    } catch (err) {
      console.error('fetchScreenConfig error:', err);
      setScreenConfig(null);
      setShowDepartmentField(false);
      return null;
    }
  };

  // Fetch branches, product details, and BOM headers when modal opens
  useEffect(() => {
    if (open ) {
      fetchBranches();
      fetchProductDetails();
      fetchScreenConfig();
      
      // Fetch production BOM headers
      fetchBomHeadersByType('production BOM', setProductionBomHeaders, setLoadingProductionBomHeaders);
      // Fetch packing BOM headers
      fetchBomHeadersByType('packing BOM', setPackingBomHeaders, setLoadingPackingBomHeaders);
    } else {
      // Reset BOM headers when modal closes
      setProductionBomHeaders([]);
      setPackingBomHeaders([]);
    }
  }, [open, productCode]);

  if (!open) {
    return null;
  }

  // Find branch name for the product's branch code
  const getBranchName = (branchCode) => {
    if (!branchCode || loadingBranches) return '';
    const branch = branches.find(b => b.BranchCode === branchCode);
    return branch ? branch.BranchName : '';
  };

  // Find department name for the product's department ID
  const getDepartmentName = (departmentId) => {
    if (!departmentId || loadingDepartments) return '';
    const department = departments.find(d => d.DepartmentID === parseInt(departmentId));
    return department ? `${department.DepartmentCode} - ${department.DepartmentName}` : '';
  };

  // Find BOM name for the product's BOM ID
  const getBomName = (bomId, bomHeaders) => {
    if (!bomId || !bomHeaders.length) return '';
    const bom = bomHeaders.find(b => b.BOMID === bomId);
    return bom ? bom.BOMName : '';
  };

  const handleFileDownload = async () => {
    if (!productData) return;

    try {
      setLoadingFile(true);
      const response = await fetch(`${API_URL}/products/${productData.ProductCode}/files/product_image`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      if (!response.ok) {
        throw new Error('Failed to download file');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${productData.ProductCode}_product_image`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading product image:', error);
    } finally {
      setLoadingFile(false);
    }
  };

  const handleFileView = async () => {
    if (!productData) return;

    try {
      setLoadingFile(true);
      const response = await fetch(`${API_URL}/products/${productData.ProductCode}/files/product_image`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      if (!response.ok) {
        throw new Error('Failed to view file');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error viewing product image:', error);
    } finally {
      setLoadingFile(false);
    }
  };

  const renderImagePreview = () => {
    if (!productData || !productData.ProductImage) {
      return '-';
    }
    const isLoading = loadingFile;
    return (
      <div className="flex items-center gap-2">
        <img
          src={`${API_URL}/products/${productData.ProductCode}/files/product_image`}
          alt="Product"
          className="w-10 h-10 object-cover rounded-md"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cmVjdCB4PSIzIiB5PSIzIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIiByeT0iMiI+PC9yZWN0PjxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iMS41Ij48L2NpcmNsZT48cG9seWxpbmUgcG9pbnRzPSIyMSAxNSAxNSAxNSA5IDkgMyAxNSI+PC9wb2x5bGluZT48L3N2Zz4=';
          }}
        />
        <button
          onClick={handleFileView}
          className="p-2 text-[#A0AEC0] hover:text-[#384959] disabled:opacity-50"
          disabled={isLoading}
          title="View"
        >
          <ViewIcon />
        </button>
        <button
          onClick={handleFileDownload}
          className="p-2 text-[#A0AEC0] hover:text-[#384959] disabled:opacity-50"
          disabled={isLoading}
          title="Download"
        >
          <DownloadIcon />
        </button>
        {isLoading && <span className="text-sm text-[#64748b]">Loading...</span>}
      </div>
    );
  };

  // Format product tracking value
  const formatProductTracking = (trackingValue) => {
    if (trackingValue === undefined || trackingValue === null || trackingValue === '') return '-';
    
    const value = parseInt(trackingValue);
    switch(value) {
      case 0: return 'None';
      case 1: return 'Batch';
      case 2: return 'Serial';
      default: return '-';
    }
  };

  // Format product type value
  const formatProductType = (productType) => {
    if (!productType) return '-';
    
    // Convert to lowercase for case-insensitive comparison
    const type = productType.toLowerCase();
    
    switch(type) {
      case 'raw material': return 'Raw Material';
      case 'semi-finished': return 'Semi-Finished';
      case 'finished goods': return 'Finished Goods';
      case 'service item': return 'Service Item';
      case 'non-inventory item': return 'Non-Inventory Item';
      default: return productType;
    }
  };

  // Define sections array similar to VendorViewModal
  const sections = [
    {
      title: 'Product Information',
      fields: [
        { label: 'Product Code', value: productData?.ProductCode || '-' },
        { label: 'Product Name', value: productData?.ProductName || '-' },
        // { label: 'Product Type', value: formatProductType(productData?.ProductType) },
        // { label: 'Category', value: productData?.ItemCategory || '-' },
        // { label: 'UOM', value: productData?.UOMName || '-' },
        
        // Department field shown based on screen-config
        // ...(showDepartmentField
        //   ? [{
        //       label: 'Department',
        //       value: getDepartmentName(productData?.DepartmentID) || '-',
        //     }]
        //   : []),

        // { 
        //   label: 'Branch', 
        //   value: productData?.BranchCode 
        //     ? `${productData.BranchCode}${getBranchName(productData.BranchCode) ? ' - ' + getBranchName(productData.BranchCode) : ''}` 
        //     : '-'
        // },
        // { 
        //   label: 'Status', 
        //   value: (
        //     <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold shadow-sm
        //       ${productData?.Status === 'Active' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
        //       {productData?.Status || '-'}
        //     </span>
        //   )
        // },
        // {
        //   label: 'Allow Negative Inventory',
        //   value: productData?.AllowProductNegativeInventory ? 'Yes' : 'No'
        // },
        {
          label: 'Product Tracking',
          value: formatProductTracking(productData?.AllowProductTracking)
        },
        {
          label: 'IsDismental',
          value: String(productData?.IsDismental)
        }
      ],
      name: 'Product Info'
    },
    // {
    //   title: 'BOM Information',
    //   fields: [
    //     {
    //       label: 'Production BOM',
    //       value: loadingProductionBomHeaders 
    //         ? 'Loading...' 
    //         : (productData?.ProductionBOMID 
    //             ? `${getBomName(productData.ProductionBOMID, productionBomHeaders)} (${productData.ProductionBOMID})` 
    //             : '-')
    //     },
    //     {
    //       label: 'Packing BOM',
    //       value: loadingPackingBomHeaders 
    //         ? 'Loading...' 
    //         : (productData?.PackingBOMID 
    //             ? `${getBomName(productData.PackingBOMID, packingBomHeaders)} (${productData.PackingBOMID})` 
    //             : '-')
    //     },
    //     {
    //       label: 'Manufacturing Policy',
    //       value: productData?.ProductionManufacturingPolicy || 
    //              productData?.PackingManufacturingPolicy || 
    //              '-'
    //     },
    //     {
    //       label: 'Flush Method',
    //       value: productData?.ProductionFlushMethod || 
    //              productData?.PackingFlushMethod || 
    //              '-'
    //     }
    //   ],
    //   name: 'BOM Info'
    // },
    // {
    //   title: 'Description',
    //   fields: [
    //     { 
    //       label: 'Short Description', 
    //       value: productData?.Description || '-',
    //       isFullWidth: true
    //     }
    //   ],
    //   name: 'Description'
    // },
    // {
    //   title: 'Documents',
    //   fields: [
    //     {
    //       label: 'Product Image',
    //       value: renderImagePreview()
    //     }
    //   ],
    //   name: 'Documents'
    // },
    // {
    //   title: 'System Information',
    //   fields: [
    //     { 
    //       label: 'Created At', 
    //       value: productData?.CreatedAt ? dayjs(productData.CreatedAt).format('YYYY-MM-DD HH:mm') : '-' 
    //     },
    //     { 
    //       label: 'Updated At', 
    //       value: productData?.UpdatedAt ? dayjs(productData.UpdatedAt).format('YYYY-MM-DD HH:mm') : '-' 
    //     },
    //     { label: 'Created By', value: productData?.CreatedBy || '-' },
    //     { label: 'Updated By', value: productData?.UpdatedBy || '-' },
    //   ],
    //   name: 'System Info'
    // }
  ];

  // Toggle maximize/minimize
  const toggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  // Show loading state if data is still being fetched
  if (loadingProduct) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <span className="text-[#2b6777] text-lg font-semibold">Loading product details...</span>
        </div>
      </div>
    );
  }

  return (
    // Updated container to be full height and pinned to the right
    <div
      className={`fixed inset-0 z-50 flex justify-center transition-all duration-300 ease-in-out
        ${open ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
    >
      <style>
        {`
          .hide-scrollbar {
            -ms-overflow-style: none; /* Internet Explorer 10+ */
            scrollbar-width: none; /* Firefox */
          }
          .hide-scrollbar::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
          }
          .custom-scrollbar::-webkit-scrollbar {
            height: 8px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        `}
      </style>
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
      {/* This is the actual slide-in panel with fixed header and scrollable content */}
      <div 
        className={`bg-white shadow-2xl ${isMaximized ? 'w-full h-full' : 'w-full max-w-6xl h-full'} flex flex-col
          transition-transform transform-gpu duration-300 ease-in-out
          ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        {/* Fixed Header */}
        <div className="flex-shrink-0 p-8 pb-6">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-[#384959]">Product Details</h2>
            <div className="flex items-center gap-3">
              <button 
                className="text-[#A0AEC0] hover:text-[#384959] transition-colors" 
                onClick={toggleMaximize}
                title={isMaximized ? "Minimize" : "Maximize"}
              >
                {isMaximized ? <MinimizeIcon /> : <MaximizeIcon />}
              </button>
              <button 
                className="text-[#A0AEC0] hover:text-[#384959] transition-colors" 
                onClick={onClose}
                title="Close"
              >
                <CloseIcon />
              </button>
            </div>
          </div>
        </div>
        
        {/* Scrollable Content Area - All sections in one form */}
        <div className="flex-grow overflow-y-auto hide-scrollbar px-8">
          <div className="space-y-6 pb-6">
            {sections.map((section, index) => (
              <div key={index} className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
                <h3 className="text-lg font-semibold text-[#384959] mb-4 flex items-center">
                  {section.name === 'Product Info' && (
                    <span className="mr-2">
                      <svg className="w-5 h-5 text-[#6A89A7]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                      </svg>
                    </span>
                  )}
                  {section.name === 'BOM Info' && (
                    <span className="mr-2">
                      <BOMIcon className="w-5 h-5 text-[#6A89A7]" />
                    </span>
                  )}
                  {section.title}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {section.fields.map((field, fieldIndex) => (
                    <div 
                      key={fieldIndex} 
                      className={`flex flex-col ${field.isFullWidth ? 'md:col-span-2' : ''}`}
                    >
                      <span className="text-sm font-medium text-[#64748b]">
                        {field.label}
                      </span>
                      <span className="text-base text-[#384959] mt-1 font-semibold break-words whitespace-normal uppercase">
                        {field.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Fixed Footer with Buttons */}
        <div className="flex-shrink-0 p-8 pt-0">
          <div className="flex justify-end gap-3">
            <button
              className="px-6 py-3 rounded-lg text-[#64748b] font-semibold transition-all duration-300 ease-in-out hover:bg-[#F1F5F9]"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductViewModal;